export default {
    getHeaderFields: state => state.headerFields,
    getRowActions: state => state.rowActions,
    getPatientOperationsTableIsShow: state => state.operationsIsShow,
    getPatientOperationEkatalogusFormIsShow: state => state.eKatFormIsShow,

    getInpatientEKatFormActions : state => state.inpatientEKatFormActions,
    getInpatientEKatFormHeaderFields : state => state.inpatientEKatFormHeaderFields
}